export default "__VITE_ASSET__64daf034__"